import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { toast } from "sonner";

export default function SuperGlobalSettings() {
    const [settings, setSettings] = useState([]);
    const [edit, setEdit] = useState({});

    const load = async () => {
        const { data } = await api.get("/platform/settings");
        setSettings(data);
        const map = {};
        data.forEach((s) => { map[s.key] = s.value; });
        setEdit(map);
    };
    useEffect(() => { load(); }, []);

    const save = async (key) => {
        try { await api.put(`/platform/settings/${key}`, { value: edit[key] }); toast.success(`${key} saved`); await load(); }
        catch { toast.error("Failed"); }
    };

    return (
        <>
            <Topbar title="Global Settings" subtitle="Platform-wide configuration" />
            <div className="flex-1 overflow-auto p-6">
                <div className="akm-card divide-y divide-border overflow-hidden max-w-3xl">
                    {settings.map((s) => (
                        <div key={s.key} className="grid grid-cols-1 gap-3 p-4 md:grid-cols-[280px,1fr,auto] md:items-center" data-testid={`setting-${s.key}`}>
                            <div>
                                <div className="font-mono text-[12px] text-muted-foreground">{s.key}</div>
                                <div className="mt-0.5 text-[11px] text-muted-foreground">{s.description}</div>
                            </div>
                            <input
                                className="akm-input"
                                value={edit[s.key] ?? ""}
                                onChange={(e) => setEdit({ ...edit, [s.key]: e.target.value })}
                            />
                            <button
                                onClick={() => save(s.key)}
                                disabled={edit[s.key] === s.value}
                                className="akm-btn-ghost disabled:opacity-50"
                                data-testid={`save-${s.key}`}
                            >
                                Save
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
